import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
  connect () {
    this.bind_dropdown();
  }

  initialize() {
    this.dropdown = null;
  }

  bind_dropdown() {
    this.dropdown = $(this.element).dropdown({
      fullTextSearch: true,
      transition: 'scale',
    })
  }

  disconnect() {
  }
};
